import spanishMessages from "ra-language-spanish";
import { mergeTranslations } from "react-admin";

spanishMessages.ra.page.dashboard = "Home";
spanishMessages.ra.action.export = "Exportar";
spanishMessages.ra.navigation.page_rows_per_page = "Registros por página :";
spanishMessages.ra.notification.logged_out = "No autorizado, necesita logearse";
spanishMessages.ra.error = "Error";


export default {
  simple: {
    action: {
      close: "Cerrar",
      resetViews: "Reset views"
    }
  },
  ...mergeTranslations(spanishMessages),
  resources: {
    customer: {
      name: "Cliente",
    },
    products: {
      name: "Productos",
      fields: {}
    },
    stock: {
      name: "Stock",
      fields: {}
    },
    orders: {
      name: "Ordenes",
      fields: {}
    }
  },
  pos: { configuration: "Configuración" }
};
